export const evenOrOdd = (num) => num % 2 === 0 ? "even" : "odd";
